import React from 'react';
import {render} from 'react-dom';
import {hashHistory} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';
import configureStore from './store/configureStore';
import Root from './containers/Root'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css'
import 'react-select/dist/react-select.css';
import 'pikaday/css/pikaday.css'
import './resources/css/style.css';

const store = configureStore();
const history = syncHistoryWithStore(hashHistory, store);

render(
	<Root store={store} history={history}/>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/index.js